const Routing = {
  Root: '/',
  Home: '/home',
  BuyProcess: '/kopa-lagerbolag/pris',
  SellOfferCreate: '/avveckla-aktiebolag/pris',
  ThankYou: '/lagerbolag-tack',
  ThankYouSellOffer: '/offert-tack',
  AdminPanel: {
    Default: '/admin/cbs',
    buyOrderDetailed: (id: string) =>
      `/admin/cbs/visa-bestallningar/beställa/${id}`,
    get Fusion() {
      return `${this.Default}/fusion`;
    },
    get FusionCreate() {
      return `${this.Fusion}/new`;
    },
    get BuyOrdersTable() {
      return `${this.Default}/visa-bestallningar`;
    },
    get BuyOrder() {
      return `${this.BuyOrdersTable}/köporder/:id`;
    },
    get SellOrders() {
      return `${this.Default}/avveckla-bolag`;
    },
    get SellOrderCreate() {
      return `${this.SellOrders}/skapa`;
    },
    get SellOffers() {
      return `${this.Default}/visa-offertforfragningar`;
    },
    get SellOrderParse() {
      return `${this.SellOrders}/skapa-bestallning`;
    },
  },
  SignIn: '/sign-in',
};

export const RoutingDynamic = {
  FusionEdit: (id: string) => [Routing.AdminPanel.Fusion, 'edit', id].join('/'),
  FusionView: (id: string) => [Routing.AdminPanel.Fusion, 'visa', id].join('/'),
  BuyOrderDocuments: (id: string) =>
    [Routing.AdminPanel.BuyOrdersTable, 'dokument', id].join('/'),
  BuyOrderEdit: (id: string) =>
    [Routing.AdminPanel.BuyOrdersTable, 'handlägg', id].join('/'),
  BuyOrderView: (id: string) =>
    [Routing.AdminPanel.BuyOrdersTable, 'beställa', id].join('/'),
  SellOrderDocuments: (id: string) =>
    [Routing.AdminPanel.SellOrders, 'visa', id].join('/'),
};

export { Routing };
